import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggingService, PurchaseService, PurchaseBasketCollectionModel, SignalRUnauthrosiedHub } from '@fgb/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgb-registration-payment-callback-page',
  templateUrl: './registration-payment-callback-page.component.html',
  styleUrls: ['./registration-payment-callback-page.component.scss'],
})
export class RegistrationPaymentCallbackPageComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  basket?: PurchaseBasketCollectionModel;
  success?: boolean;
  buttonUrl: string;

  constructor(
    private route: ActivatedRoute,
    private purchaseService: PurchaseService,
    private logService: LoggingService,
    private signalRHub: SignalRUnauthrosiedHub,
    private router: Router
  ) {}

  ngOnInit() {
    let orderId: string | null = null;
    if (this.route.snapshot.queryParamMap.keys.map((x) => x.toUpperCase()).includes('ORDERID')) {
      const orderIdQueryStringKey = this.route.snapshot.queryParamMap.keys.filter((x) => x.toUpperCase() === 'ORDERID')[0];
      orderId = this.route.snapshot.queryParamMap.get(orderIdQueryStringKey);
    }

    if (!orderId) {
      this.logService.error('No order ID could be found in the query string');
      return;
    }

    this.purchaseService
      .completeTransaction(true)
      .toPromise()
      .then(() => {
        this.router.navigateByUrl('/register/success' + `?orderId=${orderId}`);
      })
      .catch(() => {
        this.router.navigate(['/register/failure']);
      });

    this.signalRHub.connectionEstablished$.pipe(takeUntil(this._destroyed$)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
